/* MONDSTEIN by Metagon · mds-reviews.js · section mds-reviews: the endless two-row review marquee. Ported from the mock's
   site.js §11. Each row repeats its own real cards (aria-hidden, inert copies, nothing new) until the track is wider than
   one set plus the screen, then moves by exactly one set: seamless at any width. About 34 px a second (20 on phones),
   opposite directions, pauses on hover, touch, the button and off screen; reduced motion = still rows to swipe. */
import { $, $$, boot, claim, onResize, reduce } from '@mds/core';

function init(root) {
  $$('[data-marquee]', root).forEach((mq) => {
    if (!claim(mq, 'Mq')) return;
    const rows = $$('.mq-row', mq), btn = $('[data-mq-toggle]', root), label = btn && $('span', btn);
    const layout = () => {
      rows.forEach((row) => {
        const tr = $('.mq-track', row), set = $('.mq-set:not(.is-clone)', row);
        if (!tr || !set) return;
        $$('.is-clone', tr).forEach((c) => c.remove());
        const w = set.offsetWidth; if (!w) return;
        const copies = Math.max(1, Math.ceil(document.documentElement.clientWidth / w));
        for (let k = 0; k < copies; k++) {
          const copy = set.cloneNode(true);
          copy.classList.add('is-clone'); copy.setAttribute('aria-hidden', 'true'); copy.inert = true;
          tr.appendChild(copy);
        }
        row.style.setProperty('--mq-shift', w + 'px');
        row.style.setProperty('--mq-dur', Math.round(w / (innerWidth < 760 ? 20 : 34)) + 's');
      });
    };
    let still = reduce;
    const apply = () => {
      mq.classList.toggle('is-live', !still);
      rows.forEach((row) => { if (still) row.tabIndex = 0; else row.removeAttribute('tabindex'); });
      if (btn && label) {
        btn.setAttribute('aria-pressed', still ? 'true' : 'false');
        label.textContent = still ? btn.getAttribute('data-label-start') : btn.getAttribute('data-label-stop');
      }
    };
    layout(); apply();
    let rt;
    // width changes only: iOS Safari fires resize when its toolbar shows or hides while scrolling (review L5)
    onResize(() => { clearTimeout(rt); rt = setTimeout(layout, 150); }, mq, true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    if (btn) btn.addEventListener('click', () => { still = !still; apply(); });
    let held;
    mq.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') { clearTimeout(held); mq.classList.add('is-held'); } });
    ['pointerup', 'pointercancel'].forEach((t) => mq.addEventListener(t, (e) => {
      if (e.pointerType !== 'mouse') held = setTimeout(() => mq.classList.remove('is-held'), 1800);
    }));
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => mq.classList.toggle('is-off', !es[0].isIntersecting)).observe(mq);
  });
}

boot(init);
